import React from 'react';
import { Outlet } from 'react-router-dom';
import { StyledEppsParentView } from '../global/styles/styled';
import DebugHeader from './components/DebugHeader';

export const DebugWrapper: React.FC = () => {
  return (
    <StyledEppsParentView>
      <DebugHeader />
      <Outlet />
    </StyledEppsParentView>
  );
};

export default DebugWrapper;
